export enum VerifiedStatuses {
  UNWATCHED = 'unwatched',
  VALID = 'valid',
  INVALID = 'invalid',
}
